import { React, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import CheckMarkIcon from "../../../assets/icons/CheckMarkIcon";
import WarningIcon from "../../../assets/icons/WarningIcon";
import TextPill from "../TextPill/TextPill";
import StyledTooltip from "../../StyledTooltip/StyledTooltip";

export default function CarrierBookPill({
  carrierName,
  carrierStatus,
  highwayStatus,
  highwayRuleAssessment,
  icon,
  darkTheme
}) {
  const [canBook, setCanBook] = useState(false);
  const [text, setText] = useState("");
  const [backgroundColor, setBackgroundColor] = useState("");
  const [color, setColor] = useState("");
  const checkIconColor = darkTheme ? "success.90" : "success.50";
  const warningIconColor = darkTheme ? "success.90" : "warning.50";

  useEffect(() => {
    if (carrierStatus === "A" &&
      highwayStatus === "O" &&
      (highwayRuleAssessment === "A" || highwayRuleAssessment === "P")) {
      setCanBook(true);
      setText("Ready to Book");
      setColor(darkTheme ? "success.20" : "success.80");
      setBackgroundColor(darkTheme ? "success.80" : "success.10");
    } else {
      setCanBook(false);
      setText("Not Ready to Book");
      setColor(darkTheme ? "error.20" : "error.80");
      setBackgroundColor(darkTheme ? "error.80" : "error.10");
    }
  }, [carrierStatus, highwayStatus, highwayRuleAssessment]);

  return (
    <StyledTooltip
      titleObject={
        <Box>
          <Typography variant="h4">Carrier: <b>{carrierName}</b></Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {highwayStatus === "O"
              ? <CheckMarkIcon sx={{ color: checkIconColor, fontSize: "20px", marginRight: "5px" }} />
              : <WarningIcon sx={{ color: warningIconColor, fontSize: "20px", marginRight: "5px" }} />
            }
            <Typography variant="body1">Highway Status</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", marginY: "5px" }}>
            {highwayRuleAssessment === "A" || highwayRuleAssessment === "P"
              ? <CheckMarkIcon sx={{ color: checkIconColor, fontSize: "20px", marginRight: "5px" }} />
              : <WarningIcon sx={{ color: warningIconColor, fontSize: "20px", marginRight: "5px" }} />
            }
            <Typography variant="body1">Highway Rule Assessment</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {carrierStatus === "A"
              ? <CheckMarkIcon sx={{ color: checkIconColor, fontSize: "20px", marginRight: "5px" }} />
              : <WarningIcon sx={{ color: warningIconColor, fontSize: "20px", marginRight: "5px" }} />
            }
            <Typography variant="body1">Status</Typography>
          </Box>
        </ Box>
      }
    >
      <span>
        {!icon ?
          <TextPill
            value={text}
            backgroundColor={backgroundColor}
            color={color}
            padding="0 12px"
            variant="h4"
            height="max-content"
          />
          : canBook
            ? <CheckMarkIcon sx={{ color: "success.50", fontSize: "20px", marginRight: "5px" }} />
            : <WarningIcon sx={{ color: "warning.50", fontSize: "20px", marginRight: "5px" }} />
        }
      </span>
    </StyledTooltip>
  );
}

CarrierBookPill.propTypes = {
  carrierName: PropTypes.string,
  carrierStatus: PropTypes.string,
  highwayStatus: PropTypes.string,
  highwayRuleAssessment: PropTypes.string,
  icon: PropTypes.bool,
  darkTheme: PropTypes.bool
};